import history from 'utils/history';
import configureStore from './configureStore';
import initialState from './initialState';

const store = configureStore(initialState, history);

export default store;
